import { render, staticRenderFns } from "./TaraHeadcountCard.vue?vue&type=template&id=2a6c414a&scoped=true"
import script from "./TaraHeadcountCard.vue?vue&type=script&lang=js"
export * from "./TaraHeadcountCard.vue?vue&type=script&lang=js"
import style0 from "./TaraHeadcountCard.vue?vue&type=style&index=0&id=2a6c414a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6c414a",
  null
  
)

export default component.exports